export default function fieldName(name, context, index, suffix = '') {
    return context
        ? typeof index === 'number'
            ? `${context}[${index}][${name}]${suffix}`
            : `${context}[${name}]${suffix}`
        : typeof index === 'number'
            ? `${name}[${index}]${suffix}`
            : name;
}
